var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "accounting-document-amount-renderer" }, [
    _c("div", { staticClass: "unit", class: _vm.textColor }, [
      _c("span", [_vm._v(_vm._s(_vm.amountRight[0]))]),
      _c("span", [_vm._v(_vm._s(_vm.amountRight[1]))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }